/* eslint-disable */

import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import CardAccordion from '../../CardAccordion';
// import { Typography } from 'antd';

/**
 * AdvanceAmountHistory component displays advance amount data in a read-only table format.
 * It calculates row totals and grand total without any editing functionality.
 *
 * @component
 * @param {Object} props - Component props
 * @param {Array} props.data - Array of objects with from, to, amount, and remarks properties
 * @returns {JSX.Element} Read-only table displaying advance amount data
 */
const GrossRentHistory = ({ data = [], index }) => {
	// Calculate row totals and grand total

	// Format number with thousand separator and 2 decimal places

	return (
		<>
			<CardAccordion
				title={index === 0 ? 'Gross Rent History (On Creation)' : `Gross Rent History ${index} (On Modification)`}
				customHeaderSX={{
					backgroundColor: '#e1f0ff !important',
					p: '10px',
				}}
				typographySX={{ fontSize: '16px !important' }}
				darkTitle={true}
				sx={{ mb: 2 }}
			>
				<TableContainer
					className="advance-amount-table"
					sx={{
						'& table, & th, & td': {
							border: '1px solid #e0e0e0',
							borderCollapse: 'collapse',
						},
						'& th, & td': {
							p: '5px',
						},
					}}
				>
					<Table aria-label="Advance Amount table">
						<TableHead>
							<TableRow>
								<TableCell sx={{ textAlign: 'center' }}>From</TableCell>
								<TableCell sx={{ textAlign: 'center' }}>To</TableCell>
								<TableCell sx={{ textAlign: 'center' }}>Amount</TableCell>

								<TableCell sx={{ textAlign: 'center' }}>Remarks</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{data.length > 0 ? (
								data.map((row, index) => {
									return (
										<TableRow key={index}>
											<TableCell style={{ textAlign: 'center' }}>{row.from}</TableCell>
											<TableCell style={{ textAlign: 'center' }}>{row.to}</TableCell>
											<TableCell style={{ textAlign: 'right' }}>{row.amount}</TableCell>

											<TableCell>{row.remarks || ''}</TableCell>
										</TableRow>
									);
								})
							) : (
								<TableRow>
									<TableCell colSpan={5} style={{ textAlign: 'center' }}>
										No data available
									</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>
			</CardAccordion>
		</>
	);
};

export default GrossRentHistory;
